module.exports = __webpack_public_path__ + "static/img/6.dcb1c83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/6.png
// module id = ByH5
// module chunks = 1